import React, { useContext, useEffect } from 'react';
import { IntlContext } from 'react-intl';
import { setWorkoutItems } from '../store/workout.slice';
import { TranslatorManager } from 'src/_shared/managers/TranslatorManager';
import { WorkoutManager } from 'src/_shared/managers/workout.manager';
import { store } from 'src/_shared/store/configure';
import { useStoreSelector } from 'src/_shared/store/hook';
import { User, Workout } from 'src/api/entities';

export const WorkoutsView: React.FC = () => {
    const workoutManager = WorkoutManager.getInstance();

    const translator = TranslatorManager.getInstance();
    const intl = useContext(IntlContext);

    const user: User = useStoreSelector(state => state.reducer.accessSlice.loggedUser);
    const workouts: Workout[] = useStoreSelector(state => state.reducer.workoutSlice.workouts);

    useEffect(() => {
        const getItems = async () => {
            const value = (await workoutManager.search(user.id!)).data!;
            store.dispatch(setWorkoutItems({ value }));
        };
        getItems();
    }, []);

    return (
        <div className='App mt-5'>
            {workouts.length > 0 && (
                <div className='d-flex flex-column bd-highlight mb-3'>
                    {workouts.map((workout: Workout, index: number) => (
                        <>
                                <div className='d-flex flex-row justify-content-between bd-highlight mb-3'>
                                    <p>{workout.title}</p>
                                    {/* <p>{workout.customerName}</p> */}
                                </div>
                        </>
                    ))}
                </div>
            )}
        </div>
    );
};


